import { ButtonPackaging } from './Button';

export const Button = ButtonPackaging;
